<template>
  <div class='main'>
    <Button @click="majorBtn(msg,majorChange)">
      <Icon :type="icon" />{{msg}}
    </Button>
    <Modal
      v-model="modal1"
      @on-cancel="cancel"
      footer-hide
      :draggable="true"
    >
      <p slot="header">
        <span>{{msg}}专业</span>
      </p>
      <el-form
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        label-width="100px"
        class="demo-ruleForm"
      >
        <el-form-item
          label="专业名称"
          prop="orgname"
        >
          <el-input v-model="ruleForm.orgname"></el-input>
        </el-form-item>
        <el-form-item label="专业简称">
          <el-input v-model="ruleForm.orgshortname"></el-input>
        </el-form-item>
        <el-form-item label="专业编号">
          <el-input v-model="ruleForm.orgcode"></el-input>
        </el-form-item>
        <el-form-item label="负责人">
          <el-input v-model="ruleForm.manager"></el-input>
        </el-form-item>
        <el-form-item label="备注">
          <el-input
            type="textarea"
            v-model="ruleForm.description"
          ></el-input>
        </el-form-item>
        <el-form-item style="">
          <el-button
            type="primary"
            @click="submitForm('ruleForm')"
          >立即创建</el-button>
          <el-button @click="resetForm('ruleForm')">重置</el-button>
        </el-form-item>
      </el-form>
    </Modal>
  </div>
</template>
<script>
import Api from '../../api/index'
import moment from 'moment';
moment.locale('zh-cn');

export default {
  data () {
    return {
      modal1: false,
      ruleForm: {
        orgname: '',
        orgshortname: '',
        orgcode: '',
        manager: '',
        description: '',
        Schoolid: '',
      },
      rules: {
        orgname: [
          { required: true, message: '请输入学校名称', trigger: 'blur' },
        ],
      },

    }
  },
  props: {
    msg: String,
    icon: String,
    majorChange: Object,

  },
  created () {
    this.GetspecialtynList();
  },
  methods: {
    //获取专业列表
    async GetspecialtynList () {
      const res = await Api.organization.GetspecialtynList()
      if (res.success != true) return this.Message(res.msg)
      this.majorDataList = res.rows;
      this.$emit('MajorTreeList', res.rows)
    },
    //学校按钮
    async majorBtn (msg, majorChange) {
      if (msg == '编辑' && JSON.stringify(majorChange) == '{}') {
        return this.$Message.info('请选择编辑项!')
      } else if (msg == '编辑') {
        this.ruleForm = majorChange
      }
      this.modal1 = true

    },
    cancel () {

    },

    submitForm (formName) {
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          this.ruleForm.Schoolid = '0d4bc22d669f48a6aa7d18df4872cea9'
          const res = await Api.organization.SaveSpecialty(this.ruleForm)
          if (res.success != true) return this.$Message.info(res.msg)
          this.$Message.success(res.msg)
          this.ruleForm = {}
          if (res.success) this.modal1 = false;
          this.GetspecialtynList();
        } else {
          return false;
        }
      });
    },
    resetForm (formName) {
      console.log(111);
      this.ruleForm = {}
    },

  }
}
</script>
<style lang='less' scoped>
</style>